import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import './Tabs.css' // Import your CSS file
import LineChart from './LineChart'
import axios from 'axios'
import Chart from 'chart.js'
import { Modal, Button } from 'react-bootstrap'
import { MathJax, MathJaxContext } from 'better-react-mathjax'
import ScoreCards from './ScoreCards'
import ScoreTable from './ScoreTable'
import AccuracyChart from './AccuracyChart'
import ScoreTabs /* for named exports */ from './ScoreTabs'
import EnglishStatsCards from './EnglishStatsCards'
import StrengthsWeaknesses from './StrengthsWeaknesses'
import { ReactComponent as FlashIcon } from './icons/flash.svg'
import SatScoreTables from './SatScoreTables'
import SatQuestionTable from './SatQuestionTable'

const Scores = () => {
  const rolename = localStorage.getItem('role')
  const [showModal, setShowModal] = useState(false)
  const [showVideo, setShowVideo] = useState(false)
  const [questioninfo, setQuestionInfo] = useState('')
  const [currentAnswers, setCurrentAnswers] = useState([])
  const [previousAnswers, setPreviousAnswers] = useState([])
  const [vstatus, setVstatus] = useState(false)
  const handleModalOpen = async (questionid) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}getquestion/${questionid}`
      )

      if (response.status === 200) {
        console.log(response.data.trecords)
        setQuestionInfo(response.data.trecords)
      }
    } catch (error) {
      console.error('Error fetching questions:', error)
    }

    setShowModal(true)
  }

  const handleModalClose = () => {
    setShowModal(false)
  }

  const handleVideoOpen = async (questionid) => {
    console.log('handleVideoOpen called with questionid:', questionid)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}getquestion/${questionid}`
      )
      console.log('API response for getquestion:', response)
      if (response.status === 200) {
        console.log('Setting questioninfo:', response.data.trecords)
        setQuestionInfo(response.data.trecords)
      }
    } catch (error) {
      console.error('Error fetching questions:', error)
    }
    setShowVideo(true)
    console.log('showVideo set to true')
  }

  const handleVideoClose = () => {
    setShowVideo(false)
  }

  const [activeTab, setActiveTab] = useState('score-view')
  const { id } = useParams()

  // Function to parse query parameters from the URL
  const getQueryParam = (name) => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(name)
  }
  // Get student_id from URL query parameters
  let userId = getQueryParam('student_id')

  // If student_id is not present in the URL, get it from localStorage

  let downloadUrl = `/send-sarreport/${id}`
  if (!userId) {
    userId = localStorage.getItem('userid')
  } else {
    downloadUrl = `/send-sarreport/${id}?student_id=${userId}`
  }

  const handleTabClick = (tabId) => setActiveTab(tabId)

  const config = {
    loader: { load: ['[tex]/html'] },
    tex: {
      packages: { '[+]': ['html'] },
      inlineMath: [
        ['$', '$'],
        ['\\(', '\\)'],
      ],
      displayMath: [
        ['$$', '$$'],
        ['\\[', '\\]'],
      ],
      chtml: {
        minScale: 1.22,
      },
      options: {
        processHtml: true, // Enable processing of HTML tags
      },
    },
  }

  const [data, setData] = useState([])
  const [results, setResults] = useState([])
  const [results2, setResults2] = useState([])
  const [test_name, setTestName] = useState('')
  const [reading_count, setReadingCount] = useState(0)
  const [math_count, setMathCount] = useState(0)
  const [total_count, setTotalCount] = useState(0)
  const [mc1_count, setMc1Count] = useState(0)
  const [mc2_count, setMc2Count] = useState(0)
  const [tc_count, setTCCount] = useState(0)
  const [mw1_count, setMw1Count] = useState(0)
  const [mw2_count, setMw2Count] = useState(0)
  const [tw_count, setTWCount] = useState(0)
  const [mo1_count, setMo1Count] = useState(0)
  const [mo2_count, setMo2Count] = useState(0)
  const [to_count, setTOCount] = useState(0)
  const [mac1_count, setMac1Count] = useState(0)
  const [mac2_count, setMac2Count] = useState(0)
  const [tma_count, setTmaCount] = useState(0)
  const [maw1_count, setMaw1Count] = useState(0)
  const [maw2_count, setMaw2Count] = useState(0)
  const [tmw_count, setTMWCount] = useState(0)
  const [mao1_count, setMao1Count] = useState(0)
  const [mao2_count, setMao2Count] = useState(0)
  const [tmao_count, setTMAOCount] = useState(0)
  let indexModule1Section1 = 1
  let indexModule2Section1 = 1

  // Populate initial answers when the component loads (for example, using useEffect)
  useEffect(() => {
    const initialAnswers = data.map((item) => ({
      id: item.id,
      selectedAnswer: item.selectedAnswer,
    }))
    setPreviousAnswers(initialAnswers)
    setCurrentAnswers(initialAnswers)
  }, [data])

  // Initialize state for selected answers and status
  const [selectedAnswers, setSelectedAnswers] = useState(
    data.reduce((acc, item) => {
      acc[item._id] = item.selectedAnswer || '' // Set initial value of selected answers
      return acc
    }, {})
  )

  const handleInputChange = (id, newAnswer, correctAnswer) => {
    let correctOptions
    if (Array.isArray(correctAnswer)) {
      correctOptions = correctAnswer.map((option) => String(option).trim())
    } else if (typeof correctAnswer === 'string') {
      correctOptions = correctAnswer.split(',').map((option) => option.trim())
    } else {
      console.error('Invalid correctAnswer format:', correctAnswer)
      return // Exit if the format is invalid
    }

    const multipleOptions = correctOptions.length > 1
    const currentStatus = multipleOptions
      ? correctOptions.includes(newAnswer.trim())
      : newAnswer.trim() === correctOptions[0]

    // Update currentAnswers state
    setData((prevItems) =>
      prevItems.map((item) =>
        item._id === id && item.selectedAnswer !== newAnswer // Only update if value has changed
          ? { ...item, selectedAnswer: newAnswer, status: currentStatus }
          : item
      )
    )

    // Update selectedAnswers state
    setSelectedAnswers((prevSelectedAnswers) => ({
      ...prevSelectedAnswers,
      [id]: {
        selectedAnswer: newAnswer,
        status: currentStatus,
      },
    }))
  }

  // Handle change in the selected answer for a specific question
  const handleSelectChange = (id, value, citem) => {
    const currentStatus = value === citem

    // Update selectedAnswers state
    setSelectedAnswers((prevSelectedAnswers) => ({
      ...prevSelectedAnswers,
      [id]: {
        selectedAnswer: value,
        status: currentStatus, // Pass the status here as well
      },
    }))

    // Update data state
    setData((prevItems) =>
      prevItems.map((item) =>
        item._id === id ? { ...item, selectedAnswer: value } : item
      )
    )
  }

  const handleSaveAll = async (module_id, section_id) => {
    try {
      const updates = []
      // Define your additional fields
      const test_id = id // Replace with the actual test ID
      const module_type = module_id // Replace with actual module type
      const section_type = section_id // Replace with actual section type
      const user_id = userId // Replace with the actual user ID

      console.log('selectedAnswers', selectedAnswers)

      // Loop through selectedAnswers and prepare the updates array
      for (const [id, { selectedAnswer, status }] of Object.entries(
        selectedAnswers
      )) {
        const update = {
          id: id,
          selected_answer: selectedAnswer, // Use selectedAnswer from selectedAnswers
          status: status, // Use status from selectedAnswers
        }

        updates.push(update) // Push each updated answer into the updates array
      }

      // Only send the updates if there are changes
      if (updates.length > 0) {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}updatestatus`,
          {
            test_id: test_id,
            module_type: module_type,
            section_type: section_type,
            answers: updates,
            userid: user_id,
          },
          {
            headers: {
              'content-type': 'application/json',
              token: localStorage.getItem('token'),
            },
          }
        )

        // Check if the response status is success
        if (response.status === 200) {
          alert('Success! All answers have been saved for this module.')
          window.location.reload(true)
        }
      } else {
        alert('No changes detected')
      }
    } catch (error) {
      console.error('Error saving answers:', error)
    }
  }

  const chartData = {
    labels: ['R&W 1', 'R&W 2', 'Math 1', 'Math 2'],
    datasets: [
      {
        label: 'Scores',
        backgroundColor: ['#3a2f7c', '#3a2f7c', '#ed197e', '#ed197e'],
        borderColor: ['#3a2f7c', '#3a2f7c', '#ed197e', '#ed197e'],
        borderWidth: 1,
        maxBarThickness: 6,

        data: [mc1_count, mc2_count, mac1_count, mac2_count, 27],
      },
    ],
  }

  useEffect(() => {
    getReport()
    gettests(id)
    getsweekness(id)
    getsweekness2(id)
  }, [])

  const [columnWidths, setColumnWidths] = useState({
    column1: '50%',
    column2: '50%',
  })

  const getReport = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}getsatreportbyuser/${userId}/${id}`
      )
      if (response.status === 200) {
        setTestName(response.data.test_name)
        setReadingCount(response.data.readingCount)
        setMathCount(response.data.mathCount)
        setTotalCount(response.data.totalCount)
        setMc1Count(response.data.mc1Count)
        setMc2Count(response.data.mc2Count)
        setTCCount(response.data.totalrCount)
        setMw1Count(response.data.mw1Count)
        setMw2Count(response.data.mw2Count)
        setTWCount(response.data.totalwCount)
        setMo1Count(response.data.mo1Count)
        setMo2Count(response.data.mo2Count)
        setTOCount(response.data.totaloCount)
        setMac1Count(response.data.mac1Count)
        setMac2Count(response.data.mac2Count)
        setTmaCount(response.data.totalmrCount)
        setMao1Count(response.data.mao1Count)
        setMao2Count(response.data.mao2Count)
        setTMAOCount(response.data.totalmaoCount)
        setMaw1Count(response.data.maw1Count)
        setMaw2Count(response.data.maw2Count)
        setTMWCount(response.data.totalmwCount)
        setVstatus(!!response.data.vstatus)
      }
    } catch (error) {
      console.error('Error fetching questions:', error)
    }
  }

  const gettests = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getsattest/${id}/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${userId}`,
        },
      }
    )
    if (response.status === 200) {
      setData(response.data)
    }
  }

  const getsweekness = async () => {
    const section_id = 1
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getsweekness/${id}/${userId}?section_id=${section_id}`
    )
    if (response.status === 200) {
      setResults(response.data)
    }
  }

  const getsweekness2 = async () => {
    const section_id = 2
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getsweekness/${id}/${userId}?section_id=${section_id}`
    )
    if (response.status === 200) {
      setResults2(response.data)
    }
  }
  const [showDropdown, setShowDropdown] = useState(null)
  const [isReviewPopupOpen, setReviewPopupOpen] = useState(false)

  const handleDropdownToggle = (index) => {
    if (showDropdown === index) {
      setShowDropdown(null) // Close the dropdown if it's already open
    } else {
      setShowDropdown(index) // Open the dropdown for the clicked row
    }
  }
  const renderDropdownMenu = (index) => {
    if (showDropdown === index) {
      // Customize this function to render your dropdown menu items
      return (
        <div className="dropdown-tmenu">
          <button onClick={() => handleDropdownItemClick(index, 'Review')}>
            Review
          </button>
          {isReviewPopupOpen && (
            <div className="review-popup">
              <div>
                <video width="640" height="300" controls>
                  <source src="/video.mov" type="video/quicktime" />
                  <source src="/video.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <button onClick={closeReviewPopup}>Close</button>
            </div>
          )}
          <button onClick={() => handleDropdownItemClick(index, 'Questions')}>
            Questions
          </button>
          {/* Add more actions as needed */}
        </div>
      )
    }
    return null
  }
  const handleDropdownItemClick = (index, action) => {
    setReviewPopupOpen(true)
    setShowDropdown(null) // Close the dropdown after an action is clicked
  }
  // Function to close the popup
  const closeReviewPopup = () => {
    setReviewPopupOpen(false)
  }
  const Loader = ({ subject, score, range, delta, color }) => {
    return (
      <div className="summary-loader">
        <div className="loader">
          <div className="loader-rings-container">
            {/* SVG Loader */}
            <svg
              className="loader-rings"
              style={{ width: '200px', height: '200px', stroke: color }}
            >
              <circle
                className="loader-ring"
                r="96"
                cx="100"
                cy="100"
                strokeDashoffset="603.1857894892403"
                style={{
                  strokeDasharray: '603.186, 603.186',
                  strokeDashoffset: '15.0796',
                }}
              ></circle>
              <circle
                className="loader-ring"
                stroke="#dadada"
                strokeOpacity="0.3"
                r="96"
                cx="100"
                cy="100"
              ></circle>
            </svg>
            {/* Loader Text */}
            <div className="loader-text-container big">
              <div className="loader-text">{subject}</div>
              <div className="loader-score">{score}</div>
              <div className="loader-text">{range}</div>
              <div className="delta">{delta}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // ScoreCards data
  const scores = {
    English: reading_count,
    Math: math_count,
    Reading: reading_count, // For SAT, Reading & Writing is combined
    Science: '', // Not used in SAT
    Total: total_count,
  }

  // Download icon
  const DownloadIcon = ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
    >
      <path
        d="M5.43652 6.81323L6.92986 8.30657L8.42319 6.81323"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.93018 2.33325V8.26575"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6668 7.10498C11.6668 9.68331 9.91683 11.7716 7.00016 11.7716C4.0835 11.7716 2.3335 9.68331 2.3335 7.10498"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  // Prepare detailedScores for ScoreTable
  const detailedScores = {
    English: {
      correct: mc1_count + mc2_count,
      incorrect: mw1_count + mw2_count,
      omitted: mo1_count + mo2_count,
      scaleScore: reading_count,
    },
    Math: {
      correct: mac1_count + mac2_count,
      incorrect: maw1_count + maw2_count,
      omitted: mao1_count + mao2_count,
      scaleScore: math_count,
    },
    Reading: {
      correct: 0,
      incorrect: 0,
      omitted: 0,
      scaleScore: 0,
    },
    Science: {
      correct: 0,
      incorrect: 0,
      omitted: 0,
      scaleScore: 0,
    },
    Total: {
      correct: tc_count + tma_count,
      incorrect: tw_count + tmw_count,
      omitted: to_count + tmao_count,
      scaleScore: total_count,
    },
  }

  // Accuracy data
  const accuracyData = {
    'R&W 1':
      mc1_count + mw1_count + mo1_count > 0
        ? `${((mc1_count / (mc1_count + mw1_count + mo1_count)) * 100).toFixed(
            2
          )}%`
        : '0.00%',
    'R&W 2':
      mc2_count + mw2_count + mo2_count > 0
        ? `${((mc2_count / (mc2_count + mw2_count + mo2_count)) * 100).toFixed(
            2
          )}%`
        : '0.00%',
    'Math 1':
      mac1_count + maw1_count + mao1_count > 0
        ? `${(
            (mac1_count / (mac1_count + maw1_count + mao1_count)) *
            100
          ).toFixed(2)}%`
        : '0.00%',
    'Math 2':
      mac2_count + maw2_count + mao2_count > 0
        ? `${(
            (mac2_count / (mac2_count + maw2_count + mao2_count)) *
            100
          ).toFixed(2)}%`
        : '0.00%',
  }

  // Redefine ScoreViewIcon here for use in satTabs
  const ScoreViewIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M18.05 8.69992L17.2333 12.1833C16.5333 15.1916 15.15 16.4083 12.55 16.1583C12.1333 16.1249 11.6833 16.0499 11.2 15.9333L9.79999 15.5999C6.32499 14.7749 5.24999 13.0583 6.06665 9.57493L6.88332 6.08326C7.04999 5.37493 7.24999 4.75826 7.49999 4.24993C8.47499 2.23326 10.1333 1.69159 12.9167 2.34993L14.3083 2.67493C17.8 3.49159 18.8667 5.21659 18.05 8.69992Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.55 16.1583C12.0334 16.5083 11.3834 16.8 10.5917 17.0583L9.27504 17.4917C5.96671 18.5583 4.22504 17.6667 3.15004 14.3583L2.08337 11.0667C1.01671 7.75833 1.90004 6.00833 5.20837 4.94167L6.52504 4.50833C6.86671 4.4 7.19171 4.30833 7.50004 4.25C7.25004 4.75833 7.05004 5.375 6.88337 6.08333L6.06671 9.575C5.25004 13.0583 6.32504 14.775 9.80004 15.6L11.2 15.9333C11.6834 16.05 12.1334 16.125 12.55 16.1583Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5334 7.1084L14.5751 8.1334"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.71655 10.3333L12.1332 10.9499"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  // Define SAT tabs for ScoreTabs
  const satTabs = [
    {
      id: 'score-view',
      label: 'Score View',
      icon: ScoreViewIcon, // You may need to import or define this icon
    },
    {
      id: 'english',
      label: 'Reading & Writing',
      iconSrc:
        'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/4ffe6046b730fe588fcfdf85ca843642c742bb8c?placeholderIfAbsent=true',
    },
    {
      id: 'mathematics',
      label: 'Mathematics',
      iconSrc:
        'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/816b5a129f8b6899a6be68d9218633be2ccddf9d?placeholderIfAbsent=true',
    },
    {
      id: 'strength-weakness',
      label: 'Strengths & Weaknesses',
      icon: FlashIcon, // You may need to import or define this icon
    },
  ]

  // Troubleshooting log for vstatus
  console.log('vstatus in render:', vstatus)

  return (
    <div
      className="main-content-wrapper"
      style={{ width: '100%', margin: '40px 0 0 0', padding: '24px 0' }}
    >
      <div className="flex justify-between items-center mb-4 mt-2 px-8">
        <h1 className="text-xl font-bold text-[#030303]">
          {test_name} - Score Details
        </h1>
        <a
          className="flex items-center gap-2 justify-center bg-[#DE3C7D] text-white px-3 py-2.5 rounded-md text-base font-semibold shadow-none hover:bg-[#c72c6a] transition-colors duration-200"
          href={downloadUrl}
          style={{
            minWidth: 120,
            textAlign: 'center',
            textDecoration: 'none',
          }}
        >
          <span>Download Report</span>
          <DownloadIcon className="w-4 h-4 text-white" />
        </a>
      </div>
      <div
        className="middle_container px-8"
        style={{ width: '100%', maxWidth: '100%', margin: 0, padding: 0 }}
      >
        <div
          className="page-content"
          style={{ width: '100%', maxWidth: '100%', margin: 0, padding: 0 }}
        >
          {console.log(
            'Rendering Modal: showVideo',
            showVideo,
            'questioninfo',
            questioninfo
          )}
          <div className="tabbed" style={{ width: '100%', maxWidth: '100%' }}>
            <ScoreTabs
              activeTab={activeTab}
              onTabChange={handleTabClick}
              tabs={satTabs}
            />
            <div className="tab-content" style={{ width: '100%' }}>
              {activeTab === 'score-view' && (
                <>
                  <ScoreCards scores={scores} mode="sat" />
                  {/* SAT Description Block */}
                  <div className="flex items-center gap-2 mb-4 mt-4">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M7.93555 9.86368C7.79242 9.87702 7.64874 9.84472 7.52509 9.77139C7.48049 9.72561 7.44676 9.67038 7.42638 9.6098C7.40601 9.54921 7.39951 9.48482 7.40738 9.42139C7.41071 9.31442 7.42349 9.20795 7.44555 9.10322C7.46691 8.98307 7.4945 8.86413 7.52827 8.74685L7.90372 7.45502C7.94245 7.32751 7.96804 7.19637 7.98009 7.06365C7.98009 6.92048 7.99918 6.82182 7.99918 6.76456C8.00312 6.63859 7.97856 6.51335 7.92732 6.3982C7.87608 6.28305 7.79949 6.18097 7.70327 6.09956C7.46349 5.91549 7.16489 5.825 6.86327 5.84502C6.64711 5.84827 6.43264 5.88366 6.22689 5.95002C6.00205 6.02002 5.76552 6.1038 5.51735 6.20139L5.40918 6.62139C5.48235 6.59593 5.57146 6.56731 5.67327 6.53548C5.77038 6.5067 5.87106 6.49171 5.97235 6.49093C6.11444 6.47553 6.25742 6.51044 6.37644 6.58956C6.41644 6.6373 6.44636 6.69263 6.46441 6.75224C6.48245 6.81185 6.48825 6.87449 6.48144 6.93639C6.48108 7.04339 6.46935 7.15005 6.44644 7.25456C6.42415 7.36594 6.39552 7.48365 6.36052 7.60774L5.98189 8.90591C5.95138 9.02657 5.92696 9.1487 5.90872 9.27182C5.89385 9.37723 5.88641 9.48354 5.88644 9.58999C5.88567 9.71678 5.91395 9.84206 5.9691 9.95623C6.02425 10.0704 6.10481 10.1704 6.20461 10.2486C6.44809 10.4356 6.75092 10.5282 7.05732 10.5095C7.27308 10.514 7.48809 10.4828 7.6937 10.4173C7.874 10.3557 8.11476 10.2677 8.41598 10.1532L8.51781 9.75225C8.43622 9.7861 8.35219 9.81375 8.26644 9.83497C8.15799 9.85972 8.04664 9.86938 7.93555 9.86368ZM8.33327 3.73868C8.1601 3.57964 7.93193 3.49408 7.69689 3.50005C7.46197 3.49475 7.23404 3.58022 7.06052 3.73868C6.74246 4.01293 6.70694 4.49312 6.98123 4.81121C7.00567 4.83956 7.03217 4.86606 7.06052 4.8905C7.42288 5.21461 7.97091 5.21461 8.33324 4.8905C8.6513 4.61354 8.68463 4.1312 8.40767 3.81313C8.38462 3.78662 8.35976 3.76174 8.33327 3.73868Z"
                          fill="#DE3C7D"
                        />
                        <path
                          d="M7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0ZM7 13.3636C3.48545 13.3636 0.636371 10.5145 0.636371 7C0.636371 3.48545 3.48545 0.636371 7 0.636371C10.5145 0.636371 13.3636 3.48545 13.3636 7C13.3636 10.5145 10.5145 13.3636 7 13.3636Z"
                          fill="#DE3C7D"
                        />
                      </svg>
                    </span>
                    <span className="text-[#DE3C7D] text-sm">
                      These practice tests, modeled after actual exams, are
                      designed for rigorous preparation. Scores are estimates,
                      not real SAT predictions, and may change as materials and
                      scoring are refined with additional data.
                    </span>
                  </div>
                  <div className="mb-8" />
                  <SatScoreTables
                    readingWriting={{
                      m1: mc1_count,
                      m2: mc2_count,
                      total: mc1_count + mc2_count,
                      incorrect1: mw1_count,
                      incorrect2: mw2_count,
                      incorrectTotal: mw1_count + mw2_count,
                      omitted1: mo1_count,
                      omitted2: mo2_count,
                      omittedTotal: mo1_count + mo2_count,
                    }}
                    math={{
                      m1: mac1_count,
                      m2: mac2_count,
                      total: mac1_count + mac2_count,
                      incorrect1: maw1_count,
                      incorrect2: maw2_count,
                      incorrectTotal: maw1_count + maw2_count,
                      omitted1: mao1_count,
                      omitted2: mao2_count,
                      omittedTotal: mao1_count + mao2_count,
                    }}
                  />
                  <AccuracyChart accuracyData={accuracyData} />
                </>
              )}
              {activeTab === 'english' && (
                <>
                  {console.log('SAT TABLE DATA:', data)}
                  <EnglishStatsCards
                    statsData={{
                      total: 54,
                      correct: mc1_count + mc2_count,
                      incorrect: mw1_count + mw2_count,
                      omitted: mo1_count + mo2_count,
                    }}
                  />
                  <div className="text-xl font-bold text-[#222] mb-4">
                    Reading & Writing Overview
                  </div>
                  {[1, 2].map((module) => (
                    <div key={module}>
                      <SatQuestionTable
                        data={data}
                        module={module}
                        sectionId={1}
                        rolename={rolename}
                        handleSelectChange={handleSelectChange}
                        onVideoReview={handleVideoOpen}
                        onViewQuestion={handleModalOpen}
                        vstatus={vstatus}
                      />
                      {rolename === 'admin' && (
                        <div className="mt-6 mb-8 text-center">
                          <button
                            onClick={() => handleSaveAll(module, 1)}
                            className="bg-[#DE3C7D] text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-[#c72c6a] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:ring-offset-2"
                          >
                            Save Changes
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
              {activeTab === 'mathematics' && (
                <>
                  {console.log('SAT TABLE DATA:', data)}
                  <EnglishStatsCards
                    statsData={{
                      total: 44,
                      correct: mac1_count + mac2_count,
                      incorrect: maw1_count + maw2_count,
                      omitted: mao1_count + mao2_count,
                    }}
                  />
                  <div className="text-xl font-bold text-[#222] mb-4">
                    Math Overview
                  </div>
                  {[1, 2].map((module) => {
                    // Debug log for answer comparison
                    console.log(
                      'DEBUG:',
                      'selectedAnswer:',
                      data
                        .filter((item) => item.section_id == 2)
                        .find((item) => item.module == module)?.selectedAnswer,
                      'correct_answer:',
                      data
                        .filter((item) => item.section_id == 2)
                        .find((item) => item.module == module)?.correct_answer,
                      'status:',
                      data
                        .filter((item) => item.section_id == 2)
                        .find((item) => item.module == module)?.status,
                      'Array includes:',
                      Array.isArray(
                        data
                          .filter((item) => item.section_id == 2)
                          .find((item) => item.module == module)?.correct_answer
                      )
                        ? data
                            .filter((item) => item.section_id == 2)
                            .find((item) => item.module == module)
                            ?.correct_answer.includes(
                              data
                                .filter((item) => item.section_id == 2)
                                .find((item) => item.module == module)
                                ?.selectedAnswer
                            )
                        : undefined
                    )
                    return (
                      <div key={module}>
                        <SatQuestionTable
                          data={data}
                          module={module}
                          sectionId={2}
                          rolename={rolename}
                          handleSelectChange={handleSelectChange}
                          onVideoReview={handleVideoOpen}
                          onViewQuestion={handleModalOpen}
                          vstatus={vstatus}
                        />
                        {rolename === 'admin' && (
                          <div className="mt-6 mb-8 text-center">
                            <button
                              onClick={() => handleSaveAll(module, 2)}
                              className="bg-[#DE3C7D] text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-[#c72c6a] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:ring-offset-2"
                            >
                              Save Changes
                            </button>
                          </div>
                        )}
                      </div>
                    )
                  })}
                </>
              )}
              {activeTab === 'strength-weakness' && (
                <StrengthsWeaknesses
                  results={results}
                  results2={results2}
                  testType="SAT"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Custom Video Popup */}
      {showVideo &&
        (() => {
          // Dynamically construct the video URL and get question number
          let question = null
          if (Array.isArray(questioninfo) && questioninfo.length > 0) {
            question = questioninfo[0]
          } else if (questioninfo && typeof questioninfo === 'object') {
            question = questioninfo
          }
          let module =
            question &&
            (question.module_id ||
              question.module_type ||
              question.module ||
              question.moduleId)
          let section =
            question &&
            (question.section_id ||
              question.section_type ||
              question.section ||
              question.sectionId)
          let question_number =
            question &&
            (question.question_number ||
              question.questionNumber ||
              question.qnum ||
              question.number)
          let sectionCode = ''
          if (
            section === 1 ||
            section === '1' ||
            section === 'RW' ||
            section === 'Reading & Writing'
          ) {
            sectionCode = 'RW'
          } else if (
            section === 2 ||
            section === '2' ||
            section === 'M' ||
            section === 'Math'
          ) {
            sectionCode = 'M'
          }
          let testCode = ''
          if (typeof test_name === 'string' && test_name) {
            const match = test_name.match(/SAT[_ ]?Test ?(\d+)/i)
            if (match) {
              testCode = `SAT_Test${match[1]}`
            } else {
              testCode = test_name.replace(/\s+/g, '')
            }
          } else {
            testCode = 'SAT_Test1'
          }
          const satFolder = 'SAT001'
          let videoUrl = ''
          if (testCode && module && sectionCode && question_number) {
            videoUrl = `https://portal.brilliantprep.com/satvideos/${satFolder}/V1/MP4/${testCode}_M${module}_${sectionCode}_${question_number}.mp4`
          }
          return (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(20, 20, 20, 0.85)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  background: '#fff',
                  borderRadius: '24px',
                  boxShadow: '0 8px 40px rgba(0,0,0,0.25)',
                  width: 'min(90vw, 900px)',
                  maxWidth: 900,
                  padding: '0 0 24px 0',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                {/* Header */}
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '24px 32px 0 32px',
                    fontWeight: 600,
                    fontSize: 20,
                    color: '#222',
                  }}
                >
                  <span>{`Question No: ${question_number || ''}`}</span>
                  <button
                    onClick={handleVideoClose}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: 32,
                      color: '#888',
                      cursor: 'pointer',
                      lineHeight: 1,
                    }}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                {/* Video */}
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 24,
                  }}
                >
                  {videoUrl ? (
                    <video
                      width="100%"
                      height="auto"
                      controls
                      style={{
                        borderRadius: '16px',
                        maxWidth: '820px',
                        background: '#000',
                      }}
                    >
                      <source src={videoUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <div style={{ padding: 40, color: '#888', fontSize: 18 }}>
                      No video available for this question.
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })()}
      {/* Custom Question View Popup */}
      {showModal &&
        (() => {
          let question = null
          if (Array.isArray(questioninfo) && questioninfo.length > 0) {
            question = questioninfo[0]
          } else if (questioninfo && typeof questioninfo === 'object') {
            question = questioninfo
          }
          const choices = [
            { key: 'A', value: question?.choice_a },
            { key: 'B', value: question?.choice_b },
            { key: 'C', value: question?.choice_c },
            { key: 'D', value: question?.choice_d },
          ]
          const correct = question?.correct_answer
          return (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(20, 20, 20, 0.85)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  width:
                    question &&
                    (question.passage || question.figure || question.table)
                      ? 'min(98vw, 1300px)'
                      : 'min(95vw, 600px)',
                  maxWidth:
                    question &&
                    (question.passage || question.figure || question.table)
                      ? 1300
                      : 600,
                  minWidth: 350,
                  margin: '0 auto',
                  background: '#fff',
                  borderRadius: 24,
                  boxShadow: '0 8px 40px rgba(0,0,0,0.25)',
                  padding: '0 36px 32px 36px',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                }}
              >
                {/* Header */}
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '28px 36px 0 36px',
                    fontWeight: 700,
                    fontSize: 24,
                    color: '#222',
                  }}
                >
                  <span>{`Question No: ${
                    question?.question_number || ''
                  }`}</span>
                  <button
                    onClick={handleModalClose}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: 32,
                      color: '#888',
                      cursor: 'pointer',
                      lineHeight: 1,
                    }}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                <div
                  style={{
                    width: '100%',
                    height: 1,
                    background: '#eee',
                    margin: '20px 0 0 0',
                  }}
                />
                {/* Passage */}
                {question &&
                  (question.passage || question.figure || question.table ? (
                    <div
                      style={{ display: 'flex', flexDirection: 'row', gap: 0 }}
                    >
                      {/* Left column: passage, table, figure */}
                      <div style={{ flex: 1, minWidth: 0, paddingRight: 36 }}>
                        {question.passage && (
                          <div
                            className="passage_test"
                            style={{ paddingBottom: 20, paddingRight: 20 }}
                            dangerouslySetInnerHTML={{
                              __html: question.passage,
                            }}
                          />
                        )}
                        {question.table && (
                          <div
                            className="question_table"
                            style={{ paddingBottom: 20, paddingRight: 20 }}
                            dangerouslySetInnerHTML={{ __html: question.table }}
                          />
                        )}
                        {question.figure && question.figure !== '' && (
                          <div
                            style={{ marginBottom: 10, textAlign: 'center' }}
                          >
                            <img src={question.figure} alt="Question Figure" />
                          </div>
                        )}
                      </div>
                      {/* Vertical divider */}
                      <div
                        style={{
                          width: 1,
                          background: '#E5E7EB',
                          margin: '0 24px',
                        }}
                      />
                      {/* Right column: equation, question, choices */}
                      <div style={{ flex: 1, minWidth: 0, paddingLeft: 36 }}>
                        {question.equation && (
                          <MathJaxContext config={config} version={3}>
                            <MathJax inline dynamic hideUntilTypeset={'first'}>
                              <div
                                style={{
                                  textAlign: 'center',
                                  marginTop: 24,
                                  marginBottom: 16,
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: question.equation,
                                }}
                              />
                            </MathJax>
                          </MathJaxContext>
                        )}
                        <div style={{ paddingBottom: 5, paddingTop: 10 }}>
                          {question.question_type === 'Math' ? (
                            <MathJaxContext config={config} version={3}>
                              <MathJax
                                inline
                                dynamic
                                hideUntilTypeset={'first'}
                              >
                                <div
                                  style={{
                                    fontWeight: 700,
                                    fontSize: 20,
                                    color: '#4B4BFF',
                                    marginBottom: 16,
                                    lineHeight: 1.4,
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: question.question_text,
                                  }}
                                />
                              </MathJax>
                            </MathJaxContext>
                          ) : (
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 20,
                                color: '#4B4BFF',
                                marginBottom: 16,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: question.question_text,
                              }}
                            />
                          )}
                        </div>
                        {/* Render correct answer for grid-in, else render MCQ options */}
                        {question.isgridIn === 'TRUE' ||
                        question.isgridIn === true ? (
                          <div
                            style={{
                              fontSize: 18,
                              color: '#22C55E',
                              textAlign: 'center',
                              margin: '20px 0',
                            }}
                          >
                            <strong>Correct Answer:</strong>{' '}
                            {Array.isArray(question.correct_answer)
                              ? question.correct_answer.join(', ')
                              : question.correct_answer}
                          </div>
                        ) : (
                          <ul className="question_ans scrollable-container">
                            {['A', 'B', 'C', 'D'].map((choiceKey) => (
                              <div
                                key={choiceKey}
                                className="flex items-center justify-center"
                                style={{ paddingBottom: 15 }}
                              >
                                <div
                                  style={{
                                    background:
                                      question.correct_answer === choiceKey
                                        ? '#22C55E'
                                        : '#F7F7F7',
                                    color:
                                      question.correct_answer === choiceKey
                                        ? '#FFF'
                                        : '#222',
                                    border:
                                      question.correct_answer === choiceKey
                                        ? 'none'
                                        : '1px solid #D1D5DB',
                                    borderRadius: 18,
                                    fontSize: 18,
                                    fontWeight:
                                      question.correct_answer === choiceKey
                                        ? 700
                                        : 500,
                                    padding: '14px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    cursor: 'default',
                                    transition: 'background 0.2s',
                                  }}
                                  id={choiceKey}
                                  className="flex border w-full rounded-lg px-2 border-gray-500 false"
                                >
                                  <span
                                    style={{
                                      width: 38,
                                      height: 38,
                                      borderRadius: '50%',
                                      background: '#FFF',
                                      color:
                                        question.correct_answer === choiceKey
                                          ? '#22C55E'
                                          : '#A3A3A3',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontWeight: 700,
                                      fontSize: 20,
                                      marginRight: 18,
                                      border: '1.5px solid #E5E7EB',
                                    }}
                                  >
                                    {choiceKey}
                                  </span>
                                  <span style={{ flex: 1 }}>
                                    {question.question_type === 'Math' ? (
                                      <MathJaxContext
                                        config={config}
                                        version={3}
                                      >
                                        <MathJax
                                          inline
                                          dynamic
                                          hideUntilTypeset={'first'}
                                        >
                                          {
                                            question[
                                              `choice_${choiceKey.toLowerCase()}`
                                            ]
                                          }
                                        </MathJax>
                                      </MathJaxContext>
                                    ) : (
                                      <span>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              question[
                                                `choice_${choiceKey.toLowerCase()}`
                                              ] || '',
                                          }}
                                        />{' '}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div style={{ width: '100%' }}>
                      {question.equation && (
                        <MathJaxContext config={config} version={3}>
                          <MathJax inline dynamic hideUntilTypeset={'first'}>
                            <div
                              style={{
                                textAlign: 'center',
                                marginTop: 24,
                                marginBottom: 16,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: question.equation,
                              }}
                            />
                          </MathJax>
                        </MathJaxContext>
                      )}
                      <div style={{ paddingBottom: 5, paddingTop: 10 }}>
                        {question.question_type === 'Math' ? (
                          <MathJaxContext config={config} version={3}>
                            <MathJax inline dynamic hideUntilTypeset={'first'}>
                              <div
                                style={{
                                  fontWeight: 700,
                                  fontSize: 20,
                                  color: '#4B4BFF',
                                  marginBottom: 16,
                                  lineHeight: 1.4,
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: question.question_text,
                                }}
                              />
                            </MathJax>
                          </MathJaxContext>
                        ) : (
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: 20,
                              color: '#4B4BFF',
                              marginBottom: 16,
                            }}
                            dangerouslySetInnerHTML={{
                              __html: question.question_text,
                            }}
                          />
                        )}
                      </div>
                      {/* Render correct answer for grid-in, else render MCQ options */}
                      {question.isgridIn === 'TRUE' ||
                      question.isgridIn === true ? (
                        <div
                          style={{
                            fontSize: 18,
                            color: '#22C55E',
                            textAlign: 'center',
                            margin: '20px 0',
                          }}
                        >
                          <strong>Correct Answer:</strong>{' '}
                          {Array.isArray(question.correct_answer)
                            ? question.correct_answer.join(', ')
                            : question.correct_answer}
                        </div>
                      ) : (
                        <ul className="question_ans scrollable-container">
                          {['A', 'B', 'C', 'D'].map((choiceKey) => (
                            <div
                              key={choiceKey}
                              className="flex items-center justify-center"
                              style={{ paddingBottom: 15 }}
                            >
                              <div
                                style={{
                                  background:
                                    question.correct_answer === choiceKey
                                      ? '#22C55E'
                                      : '#F7F7F7',
                                  color:
                                    question.correct_answer === choiceKey
                                      ? '#FFF'
                                      : '#222',
                                  border:
                                    question.correct_answer === choiceKey
                                      ? 'none'
                                      : '1px solid #D1D5DB',
                                  borderRadius: 18,
                                  fontSize: 18,
                                  fontWeight:
                                    question.correct_answer === choiceKey
                                      ? 700
                                      : 500,
                                  padding: '14px 24px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  width: '100%',
                                  cursor: 'default',
                                  transition: 'background 0.2s',
                                }}
                                id={choiceKey}
                                className="flex border w-full rounded-lg px-2 border-gray-500 false"
                              >
                                <span
                                  style={{
                                    width: 38,
                                    height: 38,
                                    borderRadius: '50%',
                                    background: '#FFF',
                                    color:
                                      question.correct_answer === choiceKey
                                        ? '#22C55E'
                                        : '#A3A3A3',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 700,
                                    fontSize: 20,
                                    marginRight: 18,
                                    border: '1.5px solid #E5E7EB',
                                  }}
                                >
                                  {choiceKey}
                                </span>
                                <span style={{ flex: 1 }}>
                                  {question.question_type === 'Math' ? (
                                    <MathJaxContext config={config} version={3}>
                                      <MathJax
                                        inline
                                        dynamic
                                        hideUntilTypeset={'first'}
                                      >
                                        {
                                          question[
                                            `choice_${choiceKey.toLowerCase()}`
                                          ]
                                        }
                                      </MathJax>
                                    </MathJaxContext>
                                  ) : (
                                    <span>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            question[
                                              `choice_${choiceKey.toLowerCase()}`
                                            ] || '',
                                        }}
                                      />{' '}
                                    </span>
                                  )}
                                </span>
                              </div>
                            </div>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          )
        })()}
    </div>
  )
}
const cellStyle = {
  border: '1px solid #000',
  padding: '8px',
  textAlign: 'center',
}

const labelStyle = {
  display: 'block',
  margin: '4px 0',
}
export default Scores
